export const RECENT_ARENAS_KEY = 'recent_arenas';

export interface Arena {
  guid: string;
  parentGuid: string | null;
  title: string;
  description?: string;
  avatarURL?: string;
  onlineUsers: number;
  members: number;
  isOfficial: boolean;
  hasVoice?: boolean;
  ownerId?: string;
  url?: string;
  motd?: string;
  creationDate?: string;
}

export interface User {
  name?: string;
  avatar?: string;
  userName: string;
  userNameSlug: string;
  portraitId: number;
  userNameColor: string;
  status?: number;
  backgroundUrl?: string;
  role?: 'member' | 'admin' | string;
  isTalking?: boolean;
  userClient?: string;
}

export interface Friend {
  id?: string;
  userId?: string;
  userName: string;
  status?: number;
  backgroundUrl?: string;
  timestamp?: string;
  userClient?: string;
}
